<template>
    <div class="display-labels">
        <p v-if="hasSetDateRange" class="turns-filter-description">{{ dateRange }}</p>

        <p v-for="(label, index) in speedLabels" :key="'speed-' + index" class="turns-filter-description">
            Entry speed: {{ label }}
        </p>

        <p v-for="(label, index) in angleLabels" :key="'angle-' + index" class="turns-filter-description">
            Angle category: {{ label }}
        </p>

        <p v-for="(label, index) in twistingTimeLabels" :key="'times-' + index" class="turns-filter-description">
            Turn time: {{ label }}
        </p>


        <p v-for="(label, index) in accelerationLabels" :key="'accelerations-' + index"
            class="turns-filter-description">
            {{ label }}
        </p>

        <p v-for="(label, index) in decelerationLabels" :key="'decelerations-' + index"
            class="turns-filter-description">
            {{ label }}
        </p>
    </div>
</template>

<script>
import turnFiltersStore from "./turnFiltersStore";
import { getTurnEntrySpeedClassifications } from "@/utils/TurnEntrySpeedBoundaryHelpers";
import { getMeasurementUnit, MeasurementTypes } from "@/utils/MeasurementSystem";
import { UserData } from "@/components/UserData";

export default {
    computed: {
        filters() {
            return turnFiltersStore.state;
        },
        hasSetDateRange() {
            const today = new Date().toDateString();
            return (
                new Date(this.filters.range.start).toDateString() !== today ||
                new Date(this.filters.range.end).toDateString() !== today
            );
        },
        dateRange() {
            const start = new Date(this.filters.range.start).toISOString().slice(0, 10);
            const end = new Date(this.filters.range.end).toISOString().slice(0, 10);
            return `${start} – ${end}`;
        },
        speedLabels() {
            const classificationNames = UserData.getTurnEntrySpeedBoundaries().names;
            const speedText = getTurnEntrySpeedClassifications(
                UserData.getTurnEntrySpeedBoundaries(),
                getMeasurementUnit(MeasurementTypes.Speed)
            ).reduce((acc, item) => {
                acc[item.name] = item.text;
                return acc;
            }, {});
            return this.getLabels(this.filters.speedSelected, speedText, classificationNames);
        },
        angleLabels() {
            const angleText = { Low: "<60°", Medium: ">60° - <120°", High: ">120°" };
            return this.getLabels(this.filters.anglesSelected, angleText, ["Low", "Medium", "High"]);
        },
        twistingTimeLabels() {
            const timeText = {
                Low: "0–0.3s",
                Medium: "0.3–0.5s",
                High: "0.5s-1s"
            };
            return this.getLabels(this.filters.timesSelected, timeText, ["Low", "Medium", "High"]);
        },
        accelerationLabels() {
            const accelerationText = {
                Low: "Low Accelerations",
                Medium: "Medium Accelerations",
                High: "High Accelerations"
            };
            return this.getLabels(this.filters.accelerationsSelected, accelerationText, ["Low", "Medium", "High"]);
        },
        decelerationLabels() {
            const decelerationText = {
                Low: "Low Decelerations",
                Medium: "Medium Decelerations",
                High: "High Decelerations"
            };
            return this.getLabels(this.filters.decelerationsSelected, decelerationText, ["Low", "Medium", "High"]);
        }
    },
    methods: {
        getLabels(selected, labelMap, names) {
            return selected.sort().map(i => labelMap[names[i]]);
        }
    }
};
</script>
<style  scoped>
.display-labels {
    display: flex;
    flex-wrap: wrap;
    margin-top: 0.2vh;
    align-content: space-around;
}
</style>
